/* eslint-disable jsx-a11y/anchor-is-valid */
// @flow
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// components
import Table from '../../components/Table';
import { useTranslation } from 'react-i18next';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getMaintenanceMode, getUserRequestAPI, startAndStopAlertAPI } from '../../API/RDPMS_API';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import HyperDatepicker from '../../components/Datepicker';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { maintenanceModeColumns, mapRequestDataToOptions, sizePerPageList } from './requestDataMapper';

const MaintenanceMode = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    const userRole = auth?.user?.role;

    // State to store dates per asset
    const [maintenanceDates, setMaintenanceDates] = useState({});
    const [selectedRows, setSelectedRows] = useState({});

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const [selectedStartDate, setSelectedStartDate] = useState(() => {
        const today = new Date();
        const last7Days = new Date();
        last7Days.setDate(today.getDate() - 7);
        return last7Days;
    });

    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [selectedZones, setSelectedZones] = useState([]);
    const [selectedDivisions, setSelectedDivisions] = useState([]);
    const [selectedStation, setSelectedStation] = useState([]);
    const [selectedAssetsType, setSelectedAssetsType] = useState([]);
    const [selectedAssetsNumber, setSelectedAssetsNumber] = useState([]);

    const [stations, setStations] = useState([]);
    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [assetsTypeCode, setAssetsTypeCode] = useState([]);
    const [assetsType, setAssetsType] = useState([]);
    const [assetsNumber, setAssetsNumber] = useState([]);

    const [statusMessage, setStatusMessage] = useState('');
    // useEffect(() => {
    //     getMaintenanceModeData(limit, pageNumber);

    //     const fetchStation = async () => {
    //         await getRequestData(auth.user._id);
    //     };

    //     fetchStation();
    // }, []);

    useEffect(() => {
        const fetchStation = async () => {
            await getRequestData(auth.user._id);
        };

        fetchStation();
    }, []);

    useEffect(() => {
        if (stations && stations.length > 0) {
            getMaintenanceModeData(limit, pageNumber);
        }
    }, [stations]);

    const formatDateTime = (date) => {
        if (!date) return {};

        return {
            date: `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(
                2,
                '0'
            )}/${date.getFullYear()}`,
            time: `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(
                date.getSeconds()
            ).padStart(2, '0')}`,
        };
    };

    const handleDateChange = (date, asnc, type) => {
        setMaintenanceDates((prev) => ({
            ...prev, // pehle wale ASNs preserve karo
            [asnc]: {
                ...prev[asnc], // activate/clear preserve karo
                [type]: date, // sirf updated date set karo
            },
        }));
    };

    const handleSelectRow = (asnc, rowData, isChecked) => {
        setSelectedRows((prev) => {
            const updated = { ...prev };
            if (isChecked) {
                updated[asnc] = rowData; // add row
            } else {
                delete updated[asnc]; // remove row
            }
            return updated;
        });
    };

    const getMaintenanceModeData = async (limits, pages) => {
        Loading();
        let limitNumber = limits ? limits : limit;
        let pagesNumber = pages ? pages : pageNumber;

        const { date: start_date, time: start_time } = formatDateTime(selectedStartDate);
        const { date: end_date, time: end_time } = formatDateTime(selectedEndDate);

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);

        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        // const station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        let station = [];
        if (userRole === 'super admin') {
            // Existing logic
            station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        } else {
            //  user station select
            if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
                station = selectedStation.map((s) => s.value);
            } else {
                // not select station select  → get stations state
                station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
            }
        }

        const assetsType = selectedAssetsType.some((a) => a.value === 'all')
            ? []
            : selectedAssetsType.map((a) => a.value);

        const assetsNumber = selectedAssetsNumber.some((item) => item.value === 'all')
            ? []
            : selectedAssetsNumber.map((item) => ({
                  sc: item.sc,
                  asset_number_code: item.label,
              }));

        let request = {
            start_date: start_date,
            start_time: start_time,

            end_date: end_date,
            end_time: end_time,
            request: {
                zone: zone,
                division: division,
                station: station,
                asset_type: assetsType,
                asset_number: assetsNumber,
            },
            page_number: pagesNumber,
            page_size: limitNumber,
        };

        let response = await getMaintenanceMode(request);
        // console.log(response, 'response.........');

        if (response) {
            let srNo = pagesNumber * limitNumber - limitNumber + 1;
            let dataArray = [];

            response?.zone?.forEach((z) => {
                z.division?.forEach((d) => {
                    d.station?.forEach((s) => {
                        // s.alert_type?.forEach((at) => {
                        s.asset_type?.forEach((ast) => {
                            ast.asset_number?.forEach((asn) => {
                                const isDisabled = asn.master_data?.alert_status === true;
                                dataArray.push({
                                    srNo: srNo++,

                                    vcc: response.vcc || '',
                                    vcn: response.vcn || '',

                                    zoneCode: z.zc || '',
                                    divisionCode: d.dc || '',
                                    stationCode: s.sc || '',

                                    assetType: ast.astc || '',
                                    assetNumber: asn.asnc || '',
                                    master: asn.master_data || '',

                                    maintenanceMode: (
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <div
                                                style={{
                                                    border: '3px solid black',
                                                    borderRadius: '10px',
                                                    width: '80px',
                                                    height: '40px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: '600',

                                                    // 🔽 DISABLED STYLES
                                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                    opacity: isDisabled ? 0.4 : 1,
                                                    pointerEvents: isDisabled ? 'none' : 'auto',
                                                }}
                                                onClick={
                                                    isDisabled
                                                        ? undefined
                                                        : () => {
                                                              handleClearClick(asn);
                                                          }
                                                }>
                                                Clear
                                            </div>
                                        </div>
                                    ),
                                });
                            });
                        });
                    });
                });
            });

            setPageNumber(response.currentPage);
            setPageCount(response.totalPages);
            setData(dataArray);
            setTotalCount(response.totalCount);

            setStatusMessage('Alerts Maintenance mode fetched successfully');
        }
        Loading();
    };

    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);

            if (response) {
                const { stations, zones, divisions, assetsType, assetsTypeCode, assetsNumber } =
                    mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
                setAssetsType(assetsType);
                setAssetsTypeCode(assetsTypeCode);
                setAssetsNumber(assetsNumber);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getMaintenanceModeData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getMaintenanceModeData(limit, value);
    };

    const columns = [
        {
            Header: '',
            accessor: 'select',
            Cell: ({ row }) => {
                const asnc = row.original.assetNumber;
                return (
                    <input
                        type="checkbox"
                        checked={!!selectedRows[asnc]}
                        onChange={(e) => handleSelectRow(asnc, row.original, e.target.checked)}
                    />
                );
            },
        },
        {
            Header: 'Sr Number',
            accessor: 'srNo',
        },
        {
            Header: 'Vendor Name',
            accessor: 'vcc',
        },
        {
            Header: 'Zone Code',
            accessor: 'zoneCode',
        },
        {
            Header: 'Division Code',
            accessor: 'divisionCode',
        },
        {
            Header: 'Station Code',
            accessor: 'stationCode',
        },
        {
            Header: 'Asset Type',
            accessor: 'assetType',
        },
        {
            Header: 'Asset Number',
            accessor: 'assetNumber',
        },
        {
            Header: 'Date and Time of Maintenance mode to activate',
            accessor: 'activate',
            Cell: ({ row }) => {
                const asnc = row.original.assetNumber;
                return (
                    <HyperDatepicker
                        hideAddon={true}
                        type="date"
                        className="form-control"
                        dateFormat="dd/MM/yyyy HH:mm:ss"
                        showTimeSelect // Time select enable
                        timeFormat="HH:mm:ss" // 24 hour format
                        timeIntervals={30} // 30 minutes gap
                        value={maintenanceDates[asnc]?.activate || null}
                        minDate={new Date()}
                        onChange={(date) => handleDateChange(date, asnc, 'activate')}
                        popperPlacement="bottom-start"
                        popperModifiers={[
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, 10],
                                },
                            },
                            {
                                name: 'preventOverflow',
                                options: {
                                    escapeWithReference: false,
                                },
                            },
                        ]}
                        portalId="root"
                    />
                );
            },
        },
        {
            Header: 'Date and Time of Maintenance mode to clear',
            accessor: 'clear',
            Cell: ({ row }) => {
                const asnc = row.original.assetNumber;
                const activateDate = maintenanceDates[asnc]?.activate
                    ? new Date(maintenanceDates[asnc].activate)
                    : null;

                return (
                    <HyperDatepicker
                        hideAddon={true}
                        type="date"
                        className="form-control"
                        dateFormat="dd/MM/yyyy HH:mm:ss"
                        showTimeSelect // Time select enable
                        timeFormat="HH:mm:ss"
                        timeIntervals={30} // 30 minutes gap
                        value={maintenanceDates[asnc]?.clear || null}
                        minDate={activateDate || new Date()}
                        onChange={(date) => handleDateChange(date, asnc, 'clear')}
                    />
                );
            },
        },

        {
            Header: 'Maintenance Mode',
            accessor: 'maintenanceMode',
        },
    ];

    const handleClearClick = async (item) => {
        const master = item?.master_data;

        if (!master) return;

        const nameMap = {
            'DC Track Circuit': 'DC Circuit',
            'Battery Charger': 'BatteryCharger',
        };

        const request = {
            name: nameMap[master.asset_type_name] || master.asset_type_name,
            id: master.mango_master_id,
            status: true,
            isAll: false,
            stationId: master.station_id,
        };

        // console.log('CLEAR REQUEST: -', request);

        await startAndStopAlertAPI(request);

        getMaintenanceModeData(limit, pageNumber);
    };

    const handleActivate = async () => {
        const selectedArray = Object.values(selectedRows);

        // sirf valid rows jahan dono date select hai
        const finalPayload = selectedArray
            .map((row) => {
                const asnc = row.assetNumber;
                const activateDate = maintenanceDates[asnc]?.activate;
                const clearDate = maintenanceDates[asnc]?.clear;

                // Agar dono date nahi hai to skip
                if (!activateDate || !clearDate) return null;

                return {
                    activate_date_time: activateDate,
                    clear_date_time: clearDate,
                    master: row?.master,
                };
            })
            .filter(Boolean); // null rows remove

        // console.log('FINAL PAYLOAD:-', finalPayload);

        if (finalPayload.length === 0) return;

        const requests = finalPayload.map((item) => {
            const master = item.master;

            const nameMap = {
                'DC Track Circuit': 'DC Circuit',
                'Battery Charger': 'BatteryCharger',
            };

            return {
                name: nameMap[master.asset_type_name] || master.asset_type_name,
                id: master.mango_master_id,
                status: false,
                isAll: false,
                stationId: master.station_id,
                activate_date_time: item.activate_date_time,
                clear_date_time: item.clear_date_time,
            };
        });

        // console.log('REQUEST ARRAY: -', requests);

        await Promise.all(requests.map((request) => startAndStopAlertAPI(request)));

        getMaintenanceModeData(limit, pageNumber);
    };

    return (
        <>
            <ToastContainer />

            <div className=" py-1 " style={{ width: '100%' }}>
                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        {/* Alerts Overview Button */}
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                Maintenance mode
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    className="report-alert-card my-2 p-3"
                    style={{
                        width: '100%',
                        boxShadow: ' 0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    <div className="container form-container justify-content-center">
                        <form>
                            <div className="row d-flex flex-center">
                                {/* Start Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="startDate">Start Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedStartDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => setSelectedStartDate(date)}
                                        />
                                    </div>
                                    {selectedStartDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedStartDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>

                                {/* End Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="endDate">End Date</label>
                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            defaultValue="2024-08-22"
                                            id="endDate"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedEndDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => {
                                                setSelectedEndDate(date);
                                            }}
                                        />
                                    </div>
                                    {selectedEndDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedEndDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>

                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="Assets Type"
                                    id="assetsSelect"
                                    options={assetsType}
                                    selectedValues={selectedAssetsType}
                                    onChange={setSelectedAssetsType}
                                />

                                <MultiSelectDropdown
                                    label="Assets Number"
                                    id="assetsNumberSelect"
                                    options={assetsNumber}
                                    selectedValues={selectedAssetsNumber}
                                    onChange={setSelectedAssetsNumber}
                                />
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12 text-end">
                                    <button
                                        type="button"
                                        className="btn "
                                        onClick={() => getMaintenanceModeData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div
                    className="col-sm-12 card-alerts my-2 p-3 border-0  text-start no-radius"
                    style={{ width: '100%', position: 'relative' }}>
                    <div
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            width: '80px', // ↓ reduced
                            height: '80px',
                            borderRadius: '10%',
                            border: '2px solid black',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '4px',
                        }}>
                        <div
                            style={{
                                width: '62px', // ↓ reduced
                                height: '62px',
                                borderRadius: '50%',
                                backgroundColor: 'red',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontWeight: '700',
                                fontSize: '11px', // ↓ text size
                                textAlign: 'center',
                                cursor: 'pointer',
                            }}
                            onClick={handleActivate}>
                            ACTIVATE
                        </div>
                    </div>

                    <Table
                        columns={columns}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MaintenanceMode;
